import { ChannelState } from 'constants/channel-state.enum';
import React from 'react';
import { objectWithFallback } from 'utils/object-utils';

import { Typography } from '@mui/material';
import { useRecordContext } from 'ra-core';

export const ICON_MAP = objectWithFallback(
  {
    [ChannelState.CUSTOMER]: '🟢',
    [ChannelState.CANCELLED]: '🔴',
    [ChannelState.UNDER_REVIEW]: '🟤',
    [ChannelState.ACCEPTED]: '🔵',
    [ChannelState.INITIAL]: '⚪️',
    [ChannelState.FOR_FUTURE]: '🟡',
    [ChannelState.ICE_BOX]: '⚫️',
    [ChannelState.REMOVED]: '🔴',
    [ChannelState.DEMONETIZED]: '🟠',
  },
  null,
);

export function StateField({
  // source,
  iconMap,
  colorMap,
  color,
  variantMap,
  compact,
  ...props
}) {
  const record = useRecordContext() || {};
  const value = record.state;
  return (
    <Typography sx={{
      whiteSpace: 'nowrap',
      fontSize: '0.9rem',
    }}
    >
      {ICON_MAP[value]}
      {' '}
      {value}
    </Typography>
  );
}

StateField.defaultProps = {
  label: 'State',
};
